import React, { useState } from "react";
import { Button, FormFieldSet, Modal } from "../../../../../../components";
import AcceptTermsModal from "./LcaTabModals/AcceptTermsModal ";
import UploadLcaModal from "./LcaTabModals/UploadLcaModal";

const LcaTab = ({ onCreateManual }) => {
  const [uploadLca, setUploadLca] = useState(false);
  const [acceptModal, setAcceptModal] = useState(false);
  const handleAccept = () => {
    setAcceptModal(!acceptModal);
    setUploadLca(!uploadLca);
  };
  return (
    <div>
      <div className="flex flex-col items-center gap-4 p-10">
        <h3>Add LCA</h3>
        <div className="flex gap-6 mt-10">
          <Button
            title={"Upload LCA Parsing"}
            onClick={() => setUploadLca(true)}
          />
          <Button title={"Create Manuval"} onClick={onCreateManual} />
        </div>
      </div>
      {/* <Modal
        isOpen={uploadLca}
        onClose={() => setUploadLca(false)}
        title={"Accept the terms of use"}
        width="max-w-4xl"
      >
        <div className="p-1">
          <h6 className="bodytwo mb-4">
            Before you proceed please accept the following terms:
          </h6>
          <ul className="list-decimal list-inside space-y-2">
            <li>
              I understand that this is a complementary feature which accepts
              LCA PDF downloaded from DOL’s FLAG Portal only.
            </li>
            <li>
              I understand that this feature does not accept scanned documents.
            </li>
            <li>
              By using this feature I’m responsible for the data accuracy. I’ll
              review the data in the next step for it’s accuracy.
            </li>
          </ul>
          <div className="flex gap-4 mt-8 justify-end">
            <Button
              title="I Decline"
              onClick={() => setUploadLca(false)}
              variant="outlined"
            />
            <Button title="I Accept" onClick={() => handleAccept()} />
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={acceptModal}
        onClose={() => setAcceptModal(false)}
        title={"Upload LCA Document"}
        width="max-w-3xl"
      >
        <div className="p-4">
          <div>
            <FormFieldSet
              title={"Paper LCA"}
              type="file"
              placeholder=" Choose file"

            />
          </div>
          <div className="flex justify-end mt-10">
            <Button
              title="Upload"
              // onClick={() => setAcceptModal(false)}
              variant="outlined"
            />
          </div>
        </div>
      </Modal> */}

      <AcceptTermsModal
        isOpen={uploadLca}
        onClose={() => setUploadLca(false)}
        onAccept={() => handleAccept()}
        />

      <UploadLcaModal
        isOpen={acceptModal}
        onClose={() => setAcceptModal(false)}
        onAccept={onCreateManual}
      />
    </div>
  );
};

export default LcaTab;
